module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY16.9a6c07e5.jpg";